export enum InsuranceCover {
    NO_COMPREHENSIVE_INSURANCE = 'noComprehensiveInsurance',
    PARTIALLY_COMPREHENSIVE = 'partiallyComprehensive',
    FULLY_COMPREHENSIVE = 'fullyComprehensive',
}
